var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hot-counter _text-center"},[_c('div',{staticClass:"hot-counter__number",domProps:{"innerHTML":_vm._s(_vm.number)}}),_vm._v(" "),_c('div',{staticClass:"hot-counter__title",domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }